/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { devLog } from "@/utils/devLog";

const safeSetAction = (action, handler) => {
  try {
    navigator.mediaSession.setActionHandler(action, handler);
  } catch (err) {
    devLog(`MediaSession action "${action}" not supported`, err);
  }
};

/**
 * Enregistre les action handlers MediaSession (play/pause/next/prev/stop).
 * Boutons CarPlay / Android Auto / Bluetooth → fonctions de l'app.
 */
export function useMediaSessionActions({ audioRef, onZapNext, onZapPrev }) {
  useEffect(() => {
    if (!("mediaSession" in navigator)) return;
    const audio = audioRef.current;

    safeSetAction("play", () => {
      if (audio && audio.paused) {
        audio.play().catch((err) => devLog("play action failed", err));
      }
    });
    safeSetAction("pause", () => {
      if (audio && !audio.paused) audio.pause();
    });
    safeSetAction("nexttrack", () => onZapNext());
    safeSetAction("previoustrack", () => onZapPrev());
    safeSetAction("stop", () => {
      if (!audio) return;
      audio.pause();
      try {
        audio.removeAttribute("src");
        audio.load();
      } catch (err) {
        devLog("stop reset failed", err);
      }
    });
    safeSetAction("seekbackward", null);
    safeSetAction("seekforward", null);
    safeSetAction("seekto", null);
  }, [audioRef, onZapNext, onZapPrev]);
}
